import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { RecommendationQuestionsPage } from '../pages/recommendation/recommendation-questions/recommendation-questions.page';

@Injectable({
  providedIn: 'root'
})
export class RecommendationQuestionsDeactivateGuard implements CanDeactivate<RecommendationQuestionsPage> {

  constructor(
    private router: Router,
    private alertCtrl: AlertController) { }

  canDeactivate(
    page: RecommendationQuestionsPage,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canLeavePage(page)
  }

 canLeavePage(page: RecommendationQuestionsPage): Observable<boolean> | boolean {

    if (page.canLeave || !page.form.dirty) {
      return true;
    }
    else {
      var subject = new Subject<boolean>();
      this.showConfirmationDialog(subject);
      return subject.asObservable();
    }
  }

  async showConfirmationDialog(subject: Subject<boolean>) {
    const confirmDialog = await this.alertCtrl.create({
      header: "Losing Unsaved Data",
      message: "Unsaved changes on the page. Do you want to continue?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => subject.next(false)
        },
        {
          text: "Confirm",
          handler: () => subject.next(true)
        }
      ]
    });
    await confirmDialog.present();
  }

}
